export default __webpack_public_path__ + "static/media/08-analogue-situations.cf1455d7.svg";